import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function a() {
  throw new Error("Cycle detected");
}
function d() {
  if (e > 1) e--;else {
    for (var t, i = !1; h !== void 0;) {
      var o = h;
      for (h = void 0, c++; o !== void 0;) {
        var n = o.o;
        if (o.o = void 0, o.f &= -3, !(8 & o.f) && S(o)) try {
          o.c();
        } catch (_) {
          i || (t = _, i = !0);
        }
        o = n;
      }
    }
    if (c = 0, e--, i) throw t;
  }
}
var r = void 0;
var h = void 0,
  e = 0,
  c = 0,
  u = 0;
function l(t) {
  if (r !== void 0) {
    var i = t.n;
    if (i === void 0 || i.t !== r) return i = {
      i: 0,
      S: t,
      p: r.s,
      n: void 0,
      t: r,
      e: void 0,
      x: void 0,
      r: i
    }, r.s !== void 0 && (r.s.n = i), r.s = i, t.n = i, 32 & r.f && t.S(i), i;
    if (i.i === -1) return i.i = 0, i.n !== void 0 && (i.n.p = i.p, i.p !== void 0 && (i.p.n = i.n), i.p = r.s, i.n = void 0, r.s.n = i, r.s = i), i;
  }
}
function s(t) {
  this.v = t, this.i = 0, this.n = void 0, this.t = void 0;
}
s.prototype.h = function () {
  return !0;
};
s.prototype.S = function (t) {
  this.t !== t && t.e === void 0 && (t.x = this.t, this.t !== void 0 && (this.t.e = t), this.t = t);
};
s.prototype.U = function (t) {
  if (this.t !== void 0) {
    var i = t.e,
      o = t.x;
    i !== void 0 && (i.x = o, t.e = void 0), o !== void 0 && (o.e = i, t.x = void 0), t === this.t && (this.t = o);
  }
};
s.prototype.subscribe = function (t) {
  var i = this;
  return m(function () {
    var o = i.value,
      n = 32 & this.f;
    this.f &= -33;
    try {
      t(o);
    } finally {
      this.f |= n;
    }
  });
};
s.prototype.valueOf = function () {
  return this.value;
};
s.prototype.toString = function () {
  return this.value + "";
};
s.prototype.toJSON = function () {
  return this.value;
};
s.prototype.peek = function () {
  return this.v;
};
Object.defineProperty(s.prototype, "value", {
  get: function get() {
    var t = l(this);
    return t !== void 0 && (t.i = this.i), this.v;
  },
  set: function set(t) {
    if (r instanceof f && function () {
      throw new Error("Computed cannot have side-effects");
    }(), t !== this.v) {
      c > 100 && a(), this.v = t, this.i++, u++, e++;
      try {
        for (var i = this.t; i !== void 0; i = i.x) i.t.N();
      } finally {
        d();
      }
    }
  }
});
function y(t) {
  return new s(t);
}
function S(t) {
  for (var i = t.s; i !== void 0; i = i.n) if (i.S.i !== i.i || !i.S.h() || i.S.i !== i.i) return !0;
  return !1;
}
function w(t) {
  for (var i = t.s; i !== void 0; i = i.n) {
    var o = i.S.n;
    if (o !== void 0 && (i.r = o), i.S.n = i, i.i = -1, i.n === void 0) {
      t.s = i;
      break;
    }
  }
}
function b(t) {
  for (var i = t.s, o = void 0; i !== void 0;) {
    var n = i.p;
    i.i === -1 ? (i.S.U(i), n !== void 0 && (n.n = i.n), i.n !== void 0 && (i.n.p = n)) : o = i, i.S.n = i.r, i.r !== void 0 && (i.r = void 0), i = n;
  }
  t.s = o;
}
function f(t) {
  s.call(this, void 0), this.x = t, this.s = void 0, this.g = u - 1, this.f = 4;
}
(f.prototype = new s()).h = function () {
  if (this.f &= -3, 1 & this.f) return !1;
  if ((36 & this.f) == 32 || (this.f &= -5, this.g === u)) return !0;
  if (this.g = u, this.f |= 1, this.i > 0 && !S(this)) return this.f &= -2, !0;
  var t = r;
  try {
    w(this), r = this;
    var i = this.x();
    (16 & this.f || this.v !== i || this.i === 0) && (this.v = i, this.f &= -17, this.i++);
  } catch (o) {
    this.v = o, this.f |= 16, this.i++;
  }
  return r = t, b(this), this.f &= -2, !0;
};
f.prototype.S = function (t) {
  if (this.t === void 0) {
    this.f |= 36;
    for (var i = this.s; i !== void 0; i = i.n) i.S.S(i);
  }
  s.prototype.S.call(this, t);
};
f.prototype.U = function (t) {
  if (this.t !== void 0 && (s.prototype.U.call(this, t), this.t === void 0)) {
    this.f &= -33;
    for (var i = this.s; i !== void 0; i = i.n) i.S.U(i);
  }
};
f.prototype.N = function () {
  if (!(2 & this.f)) {
    this.f |= 6;
    for (var t = this.t; t !== void 0; t = t.x) t.t.N();
  }
};
f.prototype.peek = function () {
  if (this.h() || a(), 16 & this.f) throw this.v;
  return this.v;
};
Object.defineProperty(f.prototype, "value", {
  get: function get() {
    1 & this.f && a();
    var t = l(this);
    if (this.h(), t !== void 0 && (t.i = this.i), 16 & this.f) throw this.v;
    return this.v;
  }
});
function x(t) {
  var i = t.u;
  if (t.u = void 0, typeof i == "function") {
    e++;
    var o = r;
    r = void 0;
    try {
      i();
    } catch (n) {
      throw t.f &= -2, t.f |= 8, p(t), n;
    } finally {
      r = o, d();
    }
  }
}
function p(t) {
  for (var i = t.s; i !== void 0; i = i.n) i.S.U(i);
  t.x = void 0, t.s = void 0, x(t);
}
function T(t) {
  if (r !== this) throw new Error("Out-of-order effect");
  b(this), r = t, this.f &= -2, 8 & this.f && p(this), d();
}
function v(t) {
  this.x = t, this.u = void 0, this.s = void 0, this.o = void 0, this.f = 32;
}
v.prototype.c = function () {
  var t = this.S();
  try {
    if (8 & this.f || this.x === void 0) return;
    var i = this.x();
    typeof i == "function" && (this.u = i);
  } finally {
    t();
  }
};
v.prototype.S = function () {
  1 & this.f && a(), this.f |= 1, this.f &= -9, x(this), w(this), e++;
  var t = r;
  return r = this, T.bind(this, t);
};
v.prototype.N = function () {
  2 & this.f || (this.f |= 2, this.o = h, h = this);
};
v.prototype.d = function () {
  this.f |= 8, 1 & this.f || p(this);
};
function m(t) {
  var i = new v(t);
  try {
    i.c();
  } catch (o) {
    throw i.d(), o;
  }
  return i.d.bind(i);
}
var g = /*#__PURE__*/function () {
  function g(i) {
    _classCallCheck(this, g);
    _defineProperty(this, "_state", void 0);
    _defineProperty(this, "_prevState", void 0);
    this._prevState = i, this._state = y(i);
  }
  return _createClass(g, [{
    key: "setState",
    value: function setState(i) {
      this._prevState = this._state.value, this._state.value = i;
    }
  }, {
    key: "subscribe",
    value: function subscribe(i) {
      var _this = this;
      return this._state.subscribe(function (o) {
        return i(o, _this._prevState);
      });
    }
  }]);
}();
export { g as a };